import { Action } from 'vuex'
import { RootState } from '@/store/types'
import { VideoWidgetActions, VideoWidgetState } from '../types'
import axios from 'axios'

type TPayload = Parameters<VideoWidgetActions['createVideoWidget']>[0]

const createVideoWidget: Action<VideoWidgetState, RootState> = async (
  { commit },
  payload: TPayload
) => {
  commit('setProgress', 0)

  payload.data.set('external_type', 'yandex_cloud')

  const { data } = await axios.post('/api/v1/video/', payload.data, {
    onUploadProgress: (progressEvent) => {
      const progress = Math.round(
        (progressEvent.loaded / progressEvent.total) * 100
      )
      commit('setProgress', progress)
    },
    cancelToken: payload.cancelToken || undefined,
  })
  return data
}

export default createVideoWidget
